











import { Component, Vue, Prop } from 'vue-property-decorator';
import { ReleaseDto } from '@/shared/dtos/agents-admin';
import GenericTable from '@/components/agents-admin/common/GenericTable.vue';

@Component({
    components: { GenericTable }
})
export default class ReleasesTab extends Vue {
    @Prop() public releases: ReleaseDto[] = [];
    @Prop() public loading: boolean = false;

    public headers = [
        { text: 'ID', value: 'release_id', sortable: true },
        { text: 'Versión', value: 'version', sortable: true },
        { text: 'Fecha', value: 'release_date', sortable: true },
        { text: 'Descripción', value: 'description', sortable: true },
        { text: 'Producción', value: 'is_production', sortable: true },
        { text: 'Latest', value: 'is_latest', sortable: true }
    ];
}
